import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Sparkles } from 'lucide-react';
const packItems = [{
  name: 'Guía práctica de 30 días',
  value: '$97'
}, {
  name: 'Diario de Dinero en Acción',
  value: '$47'
}, {
  name: 'Plan para Salir de Deudas',
  value: '$67'
}, {
  name: 'Comienza tu Ahorro con Propósito',
  value: '$47'
}, {
  name: 'Dinero en Pareja y Familia',
  value: '$57'
}, {
  name: 'Obtén Ingresos Extra',
  value: '$67'
}, {
  name: 'Mentalidad y Afirmaciones',
  value: '$37'
}, {
  name: 'BONUS: Plantillas de Presupuesto',
  value: '$47',
  isBonus: true
}, {
  name: 'BONUS: Guía de Apps Financieras',
  value: '$31',
  isBonus: true
}];
const coverImages = ['https://cdn.magicpatterns.com/uploads/rEbP9cdsB5wKXX71QsCx5Z/portada_finanzas_faciles.png', 'https://cdn.magicpatterns.com/uploads/skbL3ibVy7bjUqX578naJR/portada_bono_4.png', 'https://cdn.magicpatterns.com/uploads/aqaWhvwqXbR7suvdSC7kHY/portada_bono2.png', 'https://cdn.magicpatterns.com/uploads/mXmUYZXmhYUCQtpTiNT7mX/portada_bono3.png', 'https://cdn.magicpatterns.com/uploads/82pjW85xD7qLnv8WLUSVLA/portada_bono1.png', 'https://cdn.magicpatterns.com/uploads/iowyRuUA8sVcfFG7ZcY8wE/portada_bono_5.png', 'https://cdn.magicpatterns.com/uploads/dsMDdhavFW6Br34VYUL9Sg/portada_bono_6.png'];
export function OfferSection() {
  return <section id="oferta" className="py-20 bg-white" data-id="element-422">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-423">
        <div className="text-center mb-12" data-id="element-424">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#1e3a5f] mb-4" data-id="element-425">
            Todo lo que necesitas en un solo lugar
          </h2>
          <p className="text-lg text-gray-600" data-id="element-426">
            Acceso inmediato • Descarga digital • De por vida
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-427">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4 mb-8" data-id="element-428">
            {coverImages.map((image, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.8,
            y: 20
          }} whileInView={{
            opacity: 1,
            scale: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative group" data-id="element-429">
                <img src={image} alt={`Portada ${index + 1}`} className="w-full rounded-lg shadow-xl group-hover:scale-105 group-hover:shadow-2xl transition-all duration-300" data-id="element-430" />
                <div className="absolute inset-0 bg-[#1e3a5f] opacity-0 group-hover:opacity-10 rounded-lg transition-opacity duration-300" data-id="element-431"></div>
              </motion.div>)}
          </div>
          <p className="text-center text-sm text-gray-500 italic" data-id="element-432">
            7 guías completas + 2 bonos exclusivos = Tu transformación
            financiera total
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden" data-id="element-433">
          <div className="bg-[#1e3a5f] text-white p-6 text-center" data-id="element-434">
            <span className="bg-[#d4a574] text-[#1e3a5f] font-bold px-4 py-1 rounded-full uppercase text-sm tracking-wider inline-block mb-2" data-id="element-435">
              Oferta Especial de Lanzamiento
            </span>
            <p className="text-[#f4e4d7]" data-id="element-436">Disponible por tiempo limitado</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-437">
            <div className="p-8 md:p-12 bg-gray-50" data-id="element-438">
              <h3 className="text-xl font-bold text-[#1e3a5f] mb-6 uppercase tracking-wide" data-id="element-439">
                Lo que recibes hoy:
              </h3>
              <ul className="space-y-4" data-id="element-440">
                {packItems.map((item, index) => <li key={index} className="flex items-center justify-between border-b border-gray-200 pb-2 last:border-0" data-id="element-441">
                    <div className="flex items-center gap-3" data-id="element-442">
                      <Check className={`w-5 h-5 ${item.isBonus ? 'text-[#d4a574]' : 'text-green-500'}`} data-id="element-443" />
                      <span className={`text-sm md:text-base ${item.isBonus ? 'font-bold text-[#1e3a5f]' : 'text-gray-700'}`} data-id="element-444">
                        {item.isBonus && <span className="text-[#d4a574] mr-1" data-id="element-445">BONUS:</span>}
                        {item.name}
                      </span>
                    </div>
                    <span className="text-gray-400 text-sm font-medium line-through decoration-gray-400" data-id="element-446">
                      {item.value}
                    </span>
                  </li>)}
              </ul>
              <div className="mt-6 flex justify-between items-center pt-4 border-t-2 border-gray-200" data-id="element-447">
                <span className="text-xl font-bold text-gray-500" data-id="element-448">
                  Valor Total Real:
                </span>
                <span className="text-2xl font-bold text-gray-500 line-through decoration-red-500" data-id="element-449">
                  $497 USD
                </span>
              </div>
            </div>

            <div className="p-8 md:p-12 flex flex-col justify-center items-center bg-white relative overflow-hidden" data-id="element-450">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#d4a574] opacity-10 rounded-bl-full" data-id="element-451" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#1e3a5f] opacity-5 rounded-tr-full" data-id="element-452" />

              <div className="text-center relative z-10" data-id="element-453">
                <p className="text-gray-500 font-medium mb-2" data-id="element-454">
                  Precio de lanzamiento hoy:
                </p>
                <div className="flex items-center justify-center gap-2 mb-2" data-id="element-455">
                  <span className="text-6xl md:text-7xl font-bold text-[#1e3a5f]" data-id="element-456">
                    $97
                  </span>
                  <span className="text-xl text-gray-500 font-medium self-end mb-4" data-id="element-457">
                    USD
                  </span>
                </div>
                <p className="text-green-600 font-bold text-sm bg-green-50 px-3 py-1 rounded-full inline-block mb-8" data-id="element-458">
                  Ahorras $400 USD (80% OFF)
                </p>

                <motion.button whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="w-full bg-[#d4a574] hover:bg-[#c29463] text-[#1e3a5f] font-bold text-xl px-8 py-4 rounded-xl shadow-lg shadow-[#d4a574]/30 transition-all flex items-center justify-center gap-2 mb-4" data-id="element-459">
                  Comprar el pack ahora
                  <ArrowRight className="w-6 h-6" data-id="element-460" />
                </motion.button>

                <div className="flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-461">
                  <Sparkles className="w-4 h-4 text-[#d4a574]" data-id="element-462" />
                  <span data-id="element-463">Acceso inmediato • Pago seguro</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}